<template>
	<div class="my-2 pb-2">
		<div v-if="name" class="flex w-full items-center px-4 py-2">
			<div class="mr-5 w-6 shrink-0"></div>
			<div
				class="w-full text-[0.8em] font-bold uppercase tracking-[1px] text-black"
			>
				{{ name }}
			</div>
		</div>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'SidebarGroup',
	props: {
		name: {
			type: String,
			default: null
		}
	}
}
</script>
